import { createFileRoute } from '@tanstack/react-router';

import { AdminPlatformLocationsPage } from '@pages/admin';

export const Route = createFileRoute('/$locale/_authenticated/admin/settings/business/locations')({
  component: AdminPlatformLocationsRoute,
});

function AdminPlatformLocationsRoute() {
  return <AdminPlatformLocationsPage />;
}
